var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastro
    ? _c("VisualizacaoCadastro", {
        attrs: {
          infosCadastro: Object.assign({}, _vm.infosCadastro, {
            protocolo: _vm.protocolo
          }),
          loading: _vm.loading,
          loadingTab: _vm.loadingTab,
          actualTab: _vm.actualTab,
          showHeader: true,
          versaoCadastro: _vm.versaoCadastro,
          cadastro: _vm.cadastro,
          processo: _vm.processo,
          historico: _vm.historico,
          cadastroContainerCustomClasses: _vm.cadastroContainerCustomClasses
        },
        on: {
          "update:actualTab": [
            function($event) {
              _vm.actualTab = $event
            },
            _vm.handleChangeTab
          ],
          "update:actual-tab": function($event) {
            _vm.actualTab = $event
          },
          "update:versaoCadastro": [
            function($event) {
              _vm.versaoCadastro = $event
            },
            _vm.handleChangeVersao
          ],
          "update:versao-cadastro": function($event) {
            _vm.versaoCadastro = $event
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3feb73e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3feb73e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/VisualizarCadastro.vue
// module id = null
// module chunks = 